import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant';

const baseURL = '';
axios.interceptors.request.use(function (config) {
  // 这里的config包含每次请求的内容
  let token = JSON.parse(window.localStorage.getItem('token'))
  if (token) {
    // 添加headers
    config.headers.token = `${token || ''}`;
  } else { }
  return config;
}, function (err) {
  return Promise.reject(err);
})

function postApi(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(`${baseURL}${url}`, params)
      .then(res => {
        const {
          data = {}, msg = '使用人数过多，页面加载中，请耐心等待或稍后尝试', code, error
        } = res.data;
        if (code == 0 || error == 200) {
          resolve({
            code: 0,
            error,
            data
          });
        } else {
          resolve({
            code
          });
          Toast(msg);
        }
      }).catch(err => {
        Toast('使用人数过多，页面加载中，请耐心等待或稍后尝试');
        reject(err);
      })
  })
}
function cardApi(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(`${baseURL}${url}`, qs.stringify(params))
      .then(res => {
        const {
          data = {}, msg = '使用人数过多，页面加载中，请耐心等待或稍后尝试', code, error
        } = res.data;
        if (code == 0 || error == 200) {
          resolve({
            code: 0,
            error,
            data
          });
        } else {
          resolve({
            code
          });
          Toast(msg);
        }
      }).catch(err => {
        Toast('使用人数过多，页面加载中，请耐心等待或稍后尝试');
        reject(err);
      })
  })
}
function getApi(url, params, contentType = 'application/x-www-form-urlencoded') {
  // loading();
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseURL}` + url, contentType === 'multipart/form-data' ? params : qs.stringify(params), { headers: { 'Content-Type': contentType } })
      .then((res) => {
        // clearLoading();
        const { data, msg = '请求失败', code, error, sign } = res.data;
        if (code == 0 || error === '200' || (sign && Object.keys(sign).length)) {
          resolve({
            code: 0,
            data,
            sign
          });
        } else {
          resolve({
            code,
            sign,
          });
          Toast.fail(msg);
        }
      })
      .catch((err) => {
        clearLoading();
        Toast.fail('网络异常');
        reject(err);
      });
  });
}

function postApiWithData(url, params, contentType = 'application/x-www-form-urlencoded') {
  loading();
  return new Promise((resolve, reject) => {
    axios
      .post(
        url,
        params,
        {
          headers: { 'Content-Type': contentType },
        },
      )
      .then((res) => {
        clearLoading();
        console.log(res);
        const { data, msg = '错误', code, error, url, name } = res.data;
        if (code == 200 || code == 0 || error == 200 || code == 101) {
          resolve({
            resCode: code || error,
            data,
            code,
            error,
            url,
            name
          });
        } else {
          resolve({
            resCode: code,
            code,
          });
          showFailToast(msg);
        }
      })
      .catch((err) => {
        showFailToast('网络错误');
        reject(err);
        console.log('err', err)
      });
  });
}

function getApiInfo(url, params, contentType = 'application/x-www-form-urlencoded') {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${url.includes('http') ? '' : baseURL}` + `${url}${params ? '?' : ''}${qs.stringify(params)}`,
        params,
        {
          headers: { 'Content-Type': contentType },
        },
      )
      .then((res) => {
        console.log('res', res)
        if (res.status == 200) {
          resolve({
            data: res.data.data,
            code: res.status
          });
        } else {
          resolve(
            {
              code: res.status
            }
          );
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export { postApi, getApi, cardApi, postApiWithData, getApiInfo }



// WEBPACK FOOTER //
// ./src/assets/api.js